import type {
  LibrarySchema,
  LibraryBookSchema,
  MediaSchema,
} from '@/types/schema';
import { populate, retrieveMedia } from '~/lib/library/data';

export const useLibraryPopulate = () => {
  const { $db } = useNuxtApp();
  const library = ref<LibrarySchema>(null);
  const libraryBook = ref<LibraryBookSchema>(null);
  const media = ref<Map<string, MediaSchema>>();

  const unload = () => {
    library.value = null;
    libraryBook.value = null;
    media.value = new Map();
  };

  const fetch = async (params, depth = 2, parents = []) => {
    const lib = await populate($db, params, depth, parents);
    if (!lib) return false;
    const md = await retrieveMedia($db, lib);
    if ((lib as LibrarySchema).type) {
      library.value = lib as LibrarySchema;
      libraryBook.value = null;
    } else {
      libraryBook.value = lib as LibraryBookSchema;
      library.value = null;
    }
    media.value = md;
    if (!library.value && !libraryBook.value) return false;
    return true;
  };

  return {
    library,
    libraryBook,
    media,
    fetch,
    unload,
  };
};
